import React from 'react'

function BlogFive() {
  return (
    <div>
        


        <>
  {/* Tmp Blog Area Start  */}
  <div className="tmp-blog-area tmp-section-gapBottom">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="section-head">
            <div className="section-sub-title center-title">
              <img
                src="assets/images/services/section-custom-menubar.png "
                alt="Corporate_service"
              />
              <span className="subtitle">LATEST BLOG</span>
            </div>
            <h2 className="title split-collab">Latest News &amp; Articles</h2>
          </div>
        </div>
      </div>
      <div className="row g-5">
        <div
          className="col-lg-4 col-md-6 col-sm-6 col-12 wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".1s">
          <div className="single-blog">
            <div className="blog-inner">
              <div className="thumbnail">
                <a href="blog-details.html">
                  <img
                    src="assets/images/blog/blog-12.png"
                    alt="Business Consulting Blog"
                  />
                </a>
                <div className="pmt-blog-meta">
                  <ul className="all-meta">
                    <li className="date">
                      <span>20</span>
                    </li>
                    <li className="month">
                      <span>JAN</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="blog-content">
                <div className="blog-head">
                  <span className="name">Sultan Ahmed</span>
                  <span className="designation">Consulting</span>
                </div>
                <div className="blog-body">
                  <a href="blog-details.html" className="title-area">
                    <h4 className="title">
                      Consulted admitting wooded is power acuteness.
                    </h4>
                  </a>
                  <p className="description">
                    There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered.
                  </p>
                </div>
                <a className="btn-read-more" href="blog-details.html">
                  <span className="read-more-text">Read More</span>
                  <span className="read-more-icon">
                    <i className="fa-solid fa-arrow-right" />
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-lg-4 col-md-6 col-sm-6 col-12 wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".3s">
          <div className="single-blog">
            <div className="blog-inner">
              <div className="thumbnail">
                <a href="blog-details.html">
                  <img
                    src="assets/images/blog/blog-10.png"
                    alt="Business Consulting Blog"
                  />
                </a>
                <div className="pmt-blog-meta">
                  <ul className="all-meta">
                    <li className="date">
                      <span>20</span>
                    </li>
                    <li className="month">
                      <span>JAN</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="blog-content">
                <div className="blog-head">
                  <span className="name">Sultan Ahmed</span>
                  <span className="designation">Consulting</span>
                </div>
                <div className="blog-body">
                  <a href="blog-details.html" className="title-area">
                    <h4 className="title">
                      Grow your business strategy with business consulting.
                    </h4>
                  </a>
                  <p className="description">
                    There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered.
                  </p>
                </div>
                <a className="btn-read-more" href="blog-details.html">
                  <span className="read-more-text">Read More</span>
                  <span className="read-more-icon">
                    <i className="fa-solid fa-arrow-right" />
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-lg-4 col-md-6 col-sm-6 col-12 wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".5s">
          <div className="single-blog">
            <div className="blog-inner">
              <div className="thumbnail">
                <a href="blog-details.html">
                  <img
                    src="assets/images/blog/blog-11.png"
                    alt="Business Consulting Blog"
                  />
                </a>
                <div className="pmt-blog-meta">
                  <ul className="all-meta">
                    <li className="date">
                      <span>20</span>
                    </li>
                    <li className="month">
                      <span>JAN</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="blog-content">
                <div className="blog-head">
                  <span className="name">Sultan Ahmed</span>
                  <span className="designation">Consulting</span>
                </div>
                <div className="blog-body">
                  <a href="blog-details.html" className="title-area">
                    <h4 className="title">
                      Facilis dolor eques about under official,presentism.
                    </h4>
                  </a>
                  <p className="description">
                    There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered.
                  </p>
                </div>
                <a className="btn-read-more" href="blog-details.html">
                  <span className="read-more-text">Read More</span>
                  <span className="read-more-icon">
                    <i className="fa-solid fa-arrow-right" />
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* Tmp Blog Area Start  */}
</>






    </div>
  )
}

export default BlogFive